import NotFound from "@/components/404";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Homes For Sale | Online Real Estate Auctions | Properties | Hubzu",
};

const NotFoundPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <NotFound />
    </>
  );
};

export default NotFoundPage;
